import React, { useState, useEffect } from "react";
import SourceQueryParams from "../../../utils/SourceQueryParams";
import TargetParams from "../../../utils/TargetParams";
import { DC_OPTIONS } from "../../../utils/DCoption";
import { authProvider } from "../../../utils/authProvider";
import { handleRunPipeline } from "../../../utils/pipelineHandler";
import "../InterfacesTab/InterfacesTab.css";

function ItemFacilityTab() {
  const [selectedEnv, setSelectedEnv] = useState("PROD");
  const [selectedDC, setSelectedDC] = useState("");
  const [selectedTGTEnvReg, setSelectedTGTEnvReg] = useState("");
  const [selectedTGTEnv, setSelectedTGTEnv] = useState("");
  const [pipelineStatus, setPipelineStatus] = useState<string | null>(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const [, setSessionExpired] = useState(false);

  const interfaceName = "ITEM FACILITY";

  // Refresh session on mount and periodically
  const refreshSession = () => {
    const { userId: uid } = authProvider();
    if (uid) {
      setUserId(uid);
      setSessionExpired(false);
    } else {
      setUserId(null);
      setSessionExpired(true);
    }
  };

  useEffect(() => {
    refreshSession(); // Initial check

    const interval = setInterval(() => {
      refreshSession(); // Refresh every 5 minutes
    }, 5 * 60 * 1000);

    return () => clearInterval(interval); // Cleanup
  }, []);

  const handleClear = () => {
    setSelectedEnv("PROD");
    setSelectedDC("");
    setSelectedTGTEnvReg("");
    setSelectedTGTEnv("");
    setPipelineStatus(null);
    sessionStorage.removeItem("selectedDC");
  };

  const runPipeline = () => {
    if (!userId) {
      setPipelineStatus("Your session has expired. Please refresh or log in again.");
      setSessionExpired(true);
      return;
    }

    handleRunPipeline({
      selectedDC,
      selectedTGTEnv,
      selectedTGTEnvReg,
      userId,
      interfaceName,
      onClear: handleClear,
      setStatus: setPipelineStatus,
      setPublishing: setIsPublishing,
    });
  };

  return (
    <>

      <SourceQueryParams
        selectedEnv={selectedEnv}
        selectedDC={selectedDC}
        sourceenvValues={["PROD"]}
        selectedDCs={DC_OPTIONS}
        onEnvChange={setSelectedEnv}
        onDCChange={(dc) => {
          setSelectedDC(dc);
          setPipelineStatus(null);
        }}
      />

      <TargetParams
        selectedDC={selectedDC}
        selectedTGTEnvReg={selectedTGTEnvReg}
        selectedTGTEnv={selectedTGTEnv}
        onTGTEnvRegChange={setSelectedTGTEnvReg}
        onTGTEnvChange={setSelectedTGTEnv}
        onRunPipeline={runPipeline}
        onClear={handleClear}
        isPublishing={isPublishing}
        pipelineStatus={pipelineStatus}
      />
    </>
  );
}

export default ItemFacilityTab;
